import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "20",
  fill: "none",
  viewBox: "0 0 21 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m9.347 2.478-5.369 5.38a1.635 1.635 0 0 0-.354 1.782l.056.118a1.63 1.63 0 0 0 1.45.89h2.11v1.633a.82.82 0 0 0 .814.817h4.892l.095-.005a.815.815 0 0 0 .72-.812v-1.633h2.109a1.63 1.63 0 0 0 1.506-1.009 1.64 1.64 0 0 0-.353-1.78l-5.37-5.38a1.63 1.63 0 0 0-2.306 0m3.599 13.887a.815.815 0 0 1 .813.77.82.82 0 0 1-.718.858l-.095.006H8.054a.814.814 0 0 1-.813-.77.82.82 0 0 1 .718-.858l.095-.006zm0-2.451a.814.814 0 0 1 .813.77.82.82 0 0 1-.718.858l-.095.006H8.054a.814.814 0 0 1-.813-.769.82.82 0 0 1 .718-.859l.095-.006z"
    }, null, -1)
  ])))
}
export default { render: render }